<template>
  <div id="app">

    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MB27469" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>

    <div>
      <header class="pageHeader">
        <!--背景白-->
        <div class="pageHeader__inner">
          <div class="container">
            <div class="row">
              <div class="col-md-5 col-lg-4 offset-lg-2 pageHeader__inner__tel_pc">
                <p class="pageHeader__innerText1">お急ぎのご注文・特注ケーキのご注文はこちら</p>
                <p class="pageHeader__innerText2">
                  <a href="tel:0942350092" class="pageHeader__innerText2--text">電話予約</a>
                  <!-- <span class="pageHeader__innerText2--text">電話予約</span> -->
                  <span class="pageHeader__innerText2--tel">0942-35-0092</span>
                </p>
              </div>
              <div class="col-4 offset-md-2 pageHeader__inner__tel_mobile">
                <a href="tel:0942-35-0092">電話をかける</a>
              </div>
              <div class="col-8 col-md-4 offset-md-2 offset-lg-0" id="pageHeaderCartBtn_first" v-show="headerBtnShow()">
                <!-- <p class="cartBtn">
                  <i class="fas fa-shopping-cart"></i>
                  カートの中身0点0 円
                </p> -->
              </div>
              <div class="col-8 col-md-4 offset-md-2 offset-lg-0" id="pageHeaderCartBtn" @click="popUpCart();">
                <p class="cartBtn"><i class="fas fa-shopping-cart"></i>カートの中身 {{ AppCartItemNumber }}点{{ Math.floor(AppSum * 0.08) + AppSum | addComma }}円</p>
              </div>
            </div>
          </div>
        </div>

        <h1 class="topLogo" id="top__logo">
          <router-link to="/"><img src="./assets/img/logo.png" alt="銀のすぷーん 店頭受取ご予約サイト" srcset="./assets/img/logo@2x.png 2x, ./assets/img/logo.svg" class="topLogo__img"></router-link>
        </h1>
      </header>

      <transition name="fade">
        <router-view ref="router" :AppSum="AppSum" @returnAppSum="returnAppSum" @setAppSum="setAppSum"/>
      </transition>
      
      <footer class="pageFooter"><p>© 2018 有限会社 銀のすぷーん.</p></footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      AppSum: 0,
      AppCartItemNumber:0,
      stepNumber:1
    }
  },
  updated () {
    const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
    if (pageHeaderCartBtn.style.display == "none") {
      this.headerBtnShow()
    }
  },
  filters: {
    addComma: function (val) {
      return String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  },
  mounted: function(){

  },
  methods: {
    popUpCart: function () {
      this.$refs.router.popUpCart ()
    },
    returnAppSum: function () {
      this.$refs.router.returnAppSum ()
    },
    setAppSum: function (sum, number) {
      this.AppSum = sum
      this.AppCartItemNumber = number
    },
    clear: function () {
      this.$refs.router.clear ()
    },
    //headerのボタンのdisplay
    headerBtnShow: function () {
      if (document.getElementById('pageHeaderCartBtn')) {
        const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
        if (pageHeaderCartBtn.style.display == "block") {
          // console.log("false")
          return false
        } else {
          // console.log("true1")
          return true
        }
      } else {
        // console.log("true2")
        return true
      }
    }
  }
}
</script>

<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
	img {
		max-width: 100%;

	}
  .pageHeader {
    position: relative;
    font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN",HGS明朝E,メイリオ,Meiryo,serif;
    &__inner {
      &Text1 {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.92;
        text-align: left;
        color: #03365b;
        margin-top: 10px;
      }
      &__tel {
        &_pc {
          display: block;
          @media (max-width: 767.98px) {
            display: none;
          }
        }
        &_mobile {
          display: none;
          @media (max-width: 767.98px) {
            display: block;
            margin-top: 17px;
            margin-bottom: 17px;
          }
          a {
            display: block;
            padding: 12px;
            background: #0d446f;
            color: #fff;
            border-radius: 50px;
            text-align: center;
            font-size: 11px;
            &:hover {
              opacity: 0.7;
              text-decoration: none;
            }
            @media (max-width: 767.98px) {
              padding: 12px 5px;
            }
          }
        }
      }
      &Text2 {
        display: flex;
        align-items: center;
        &--text {
          border-radius: 50px;
          background-color: #0d446f;
          padding: 5px 12px;
          font-size: 12px;
          font-weight: 500;
          line-height: 1.58;
          text-align: center;
          color: #ffffff;
          margin-right: 9px;
          &:hover {
            opacity: 0.7;
            color: #fff;
            text-decoration: none;
          }
        }
        &--tel {
          font-style: italic;
          font-size: 23px;
          font-weight: 500;
          line-height: 1;
          text-align: center;
          color: #03365b;
        }
      }
    }
    .cartBtn {
      border-radius: 50px;
      background-image: linear-gradient(to right, #af9630, #947a11);
      box-shadow: 0px 3px 10px 0 rgba(0, 0, 0, 0.1);
      margin-left: auto;
      margin-top: 17px;
      font-size: 14px;
      line-height: 1.64;
      text-align: center;
      color: #ffffff;
      padding: 8px 2px;
      i {
        margin-right: 5px;
      }
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
    .topLogo {
      position: absolute;
      left: 50%;
      margin-left: -150px;
      bottom: -120px;
      z-index: 10;
      width: 300px;
      @media (max-width: 767.98px) {
        width: 300px;
      }
    }
  }
  .pageFooter {
    text-align: center;
    font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN",HGS明朝E,メイリオ,Meiryo,serif !important;
  }
  #pageHeaderCartBtn {
    display: none;
  }
</style>
